var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dialog',{ref:"dialog",attrs:{"config":_vm.config,"beforeClose":_vm.beforeClose,"visible":_vm.visible,"cancelDialog":_vm.cancelDialog,"confirmDialog":_vm.confirmDialog}},[_c('p',[_vm._v("1. 小企业会计准则是按照2013年版 《小企业会计准则》设 置，为了使报表取数准确，系统不允许增加一级科目， 但可以增加二级、三级和四级科目。")]),_c('p',[_vm._v("2. 企业会计准则是按照2007年版 《企业会计准则》设置， 系统可以增加一级科目，也可以增加二级、三级和四级 科目。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }